import React, { useEffect, useState, useContext } from 'react';
import Card from './Card'; 
import CardListProps from '../interfaces/CardListProps';
import Review from '../interfaces/Review';
import '../styles/CardList.css'
import dbActions from '../utils/db';
import AppContext from '../context/AppContext'

const CardList: React.FC<CardListProps> = ({ location }) => {
  const [reviews, setReviews] = useState<Review[]>([]);
  const { addressRef } = useContext(AppContext);

  useEffect(() => { 
    (async() => {
      const retrievedReviews = await dbActions.getReviews(location.locationId);
      setReviews(retrievedReviews);
    })()
  }, [location])

  return (
    <>
      <h1 className='cards-address' ref={addressRef}>{location.place.address}</h1>
      <section className='card-container'>
        <div className="card-list">
          {reviews.map((review) => (
            <Card
            review={review}
            address={location.place.address}
            locationId={location.locationId as string}
            />)
            )}
        </div>
      </section>
    </>
  );
};

export default CardList;
